import { ChangeEvent } from 'react';

import { Upload } from 'lucide-react';

import { cn } from '../../../../lib/utils';
import type { UploadConfig } from './uploadConfig';

interface UploadDropzoneProps {
  config: UploadConfig;
  disabled?: boolean;
  inputKey: number;
  onFilesSelected: (files: File[]) => void;
}

const UploadDropzone = ({ config, disabled, inputKey, onFilesSelected }: UploadDropzoneProps) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { files } = e.target;
    if (files?.length) onFilesSelected(Array.from(files));
  };

  return (
    <label
      className={cn(
        'flex min-h-48 cursor-pointer flex-col items-center justify-center gap-4 rounded-xl border-2 border-dashed border-border-default bg-bg-surface-raised px-8 py-8 text-center transition-colors',
        disabled ? 'cursor-not-allowed opacity-50' : 'hover:border-brand-vivid'
      )}
      htmlFor={`${config.kind}-upload`}
    >
      <span className={cn('flex size-14 items-center justify-center rounded-2xl', config.iconClassName)}>
        <Upload className="size-6" />
      </span>
      <span className="font-display text-base font-bold text-text-default">{config.description}</span>
      <span className="text-sm text-text-muted">
        o <span className="font-semibold text-brand-vivid">selecciona archivos</span>
      </span>
      <span className="flex flex-wrap justify-center gap-2">
        {config.formats.map((format) => (
          <span
            key={format}
            className="rounded-full border border-border-subtle bg-bg-surface px-3 py-1 text-xs font-semibold text-text-muted"
          >
            {format}
          </span>
        ))}
      </span>
      <input
        key={inputKey}
        id={`${config.kind}-upload`}
        accept={config.accept}
        className="sr-only"
        disabled={disabled}
        multiple
        onChange={handleChange}
        type="file"
      />
    </label>
  );
};

export default UploadDropzone;
